import { useReactiveVar } from '@apollo/client'
import { storeIdsVar, inventoryLocationIdsVar, pageVar, defaultStoresAppliedVar } from 'graphql/reactive-variables'
import { useEffect } from 'react'
import useDefaultStoreIds from './userPreferences/useDefaultStoreIds'

let defaultInitialized = false

export default function useStoreIds() {
	const { initialized, defaultStoreIds } = useDefaultStoreIds()
	const storeIds = useReactiveVar( storeIdsVar )
	const inventoryLocationIds = useReactiveVar( inventoryLocationIdsVar )
	const defaultStoresApplied = useReactiveVar( defaultStoresAppliedVar )

	const setStoreIds = ( ids: number[] ) => {
		storeIdsVar( ids )
		pageVar( 0 )
	}

	const setInventoryLocationIds = ( ids: string[] ) => {
		inventoryLocationIdsVar( ids )
		pageVar( 0 )
	}

	// Initialize default value if defaultStoreIds has been initialized (ie query has responded)
	useEffect( () => {
		if ( !initialized || defaultStoresAppliedVar() ) {
			return
		}
		if ( !defaultInitialized && defaultStoreIds !== undefined ) {
			defaultInitialized = true
			setStoreIds( defaultStoreIds )
			setInventoryLocationIds( defaultStoreIds.map( ( id ) => id.toString() ) )
		}
		// Applied, or there was nothing to apply — either way the selection has settled.
		defaultStoresAppliedVar( true )
	}, [ initialized, defaultStoreIds ] )

	return {
		storeIds,
		setStoreIds,
		inventoryLocationIds,
		setInventoryLocationIds,
		defaultStoresApplied,
	}
}
